import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex justify-between mb-m" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Bitte vervollständigen Sie Ihr Profil", -1)

import CenteredCard from "@/components/CenteredCard.vue";
import { getColor } from "@/helpers/colorhelper";
import { ref, computed, onMounted } from "vue";
import { supabase } from "@/helpers/supabase";

import { useAccountStore } from "@/store/accountStore";
import { useSessionStore } from "@/store/sessionStore";
import ProfileCircle from "@/components/ProfileCircle.vue";
import UmanaHeadline from "@/components/UmanaHeadline.vue";
import LogoutLink from "@/modules/Settings/components/LogoutLink.vue";
import { saveEncryptionPassword } from "@/helpers/requestHelpers/profileRequests";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateProfileView',
  setup(__props) {

const accountStore = useAccountStore();
const sessionStore = useSessionStore();

const profileForm = ref<any>({});
const profileColor = ref<string>(getColor());

const profile = computed<any>(() => {
  return {
    first_name: profileForm.value.firstName,
    last_name: profileForm.value.lastName,
    color: profileColor.value,
    id: "",
  };
});

const setProfile = async () => {
  let result = await supabase
    .from("profile")
    .upsert([
      {
        first_name: profileForm.value.firstName,
        last_name: profileForm.value.lastName,
        color: profileColor.value,
      },
    ])
    .select();
  if (!sessionStore.salt) {
    sessionStore.password = profileForm.value.password;

    if (result.error) throw result.error;
    result = await saveEncryptionPassword(profileForm.value.password);

    if (result.error) {
      window._paq.push([
        "trackEvent",
        "Profile-Create",
        "failed - encryption password fail",
      ]);
      throw result.error;
    }

    await accountStore.loadCpgs();
  }

  window._paq.push([
    "trackEvent",
    "Profile-Create",
    "success - profile created",
  ]);

  await accountStore.loadProfile();
};

function newProfileColor() {
  profileColor.value = getColor();
}

onMounted(() => {
  loadData();
});

async function loadData() {
  const result = await supabase
    .from("profile")
    .select(
      `
          *
        `
    )
    .eq("id", sessionStore.session?.user.id);
  if (
    result.data &&
    result.data[0] &&
    !result.data[0].first_name.includes("@") // ignore current data on setup
  ) {
    profileForm.value.firstName = result.data[0].first_name;
    profileForm.value.lastName = result.data[0].last_name;
    profileColor.value = result.data[0].color;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createBlock(CenteredCard, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createVNode(UmanaHeadline, { h: "h1" }, {
            default: _withCtx(() => [
              _createTextVNode("mediBe")
            ]),
            _: 1
          }),
          _createVNode(UmanaHeadline, {
            h: "h2",
            class: "mb-s"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Herzlich Willkommen")
            ]),
            _: 1
          })
        ]),
        _createVNode(ProfileCircle, {
          profile: profile.value,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (newProfileColor()))
        }, null, 8, ["profile"])
      ]),
      _hoisted_2,
      _createVNode(_component_FormKit, {
        type: "form",
        modelValue: profileForm.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((profileForm).value = $event)),
        "submit-label": "Profil speichern",
        onSubmit: setProfile
      }, {
        default: _withCtx(() => [
          _createVNode(_component_FormKit, {
            class: "inputField",
            validation: "required",
            type: "text",
            name: "firstName",
            label: "Vorname",
            placeholder: "Vorname"
          }),
          _createVNode(_component_FormKit, {
            validation: "required",
            label: "Nachname",
            type: "text",
            name: "lastName",
            placeholder: "Nachname"
          }),
          (!_unref(sessionStore).salt)
            ? (_openBlock(), _createBlock(_component_FormKit, {
                key: 0,
                type: "password",
                name: "password",
                label: "Passwort",
                help: "Mit diesem Passwort werden alle Daten verschlüsselt.",
                placeholder: "Passwort",
                validation: "required"
              }))
            : _createCommentVNode("", true),
          (!_unref(sessionStore).salt)
            ? (_openBlock(), _createBlock(_component_FormKit, {
                key: 1,
                type: "password",
                label: "Passwort bestätigen",
                name: "password_confirm",
                validation: "required|confirm",
                placeholder: "Neues Passwort"
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(LogoutLink)
    ]),
    _: 1
  }))
}
}

})